module.exports = __webpack_public_path__ + "media/images/icon-box-0e74a16b1bd30b659e2c20626e85ba71.svg";